import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { safeRest } from '../../utils/functions.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { LegendWrapper } from './styledComponents.js';

var _excluded = ["customStyle", "children"];
var Legend = function Legend(_ref) {
  var customStyle = _ref.customStyle,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _safeCustomStyle = safeCustomStyle(customStyle),
    legendStyle = _safeCustomStyle.legendStyle;
  var safeProps = safeRest(rest);
  return /*#__PURE__*/React.createElement(LegendWrapper, _extends({
    legendStyle: legendStyle
  }, safeProps), children);
};
process.env.NODE_ENV !== "production" ? Legend.propTypes = {
  /** Content for the legend */
  children: PropTypes.node.isRequired,
  /** Style overrides */
  customStyle: PropTypes.shape({
    legendStyle: PropTypes.object
  })
} : void 0;
Legend.defaultProps = {
  customStyle: {
    legendStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? Legend.displayName = 'Legend' : void 0;
var Legend$1 = Legend;

export { Legend$1 as default };
